import { useEffect } from "react";
import HeroSpotlight from "../sections/HeroSpotlight";
import Manifesto from "../sections/Manifesto";
import Timeline from "../sections/Timeline";
import QuoteMarquee from "../sections/QuoteMarquee";
import Verdict from "../sections/Verdict";
import KeywordStrip from "../sections/KeywordStrip";
import ClosingCTA from "../sections/ClosingCTA";
import SEO from "../components/SEO";
import { getStats, PRODUCTIONS, REVIEWS } from "../data/reviews";

export default function Home() {
  const stats = getStats();

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "TheaterGroup",
      name: "COLAB Theatre",
      alternateName: ["COLAB", "COLAB Theatre Productions"],
      url: "https://www.colabtheatre.co.uk/",
      description:
        "London's leading immersive theatre company. 14 years of immersive productions from Fifth Column (2014) to The End (2026).",
      foundingDate: "2011",
      location: { "@type": "Place", name: "London, United Kingdom" },
      areaServed: "London",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: stats.average_rating,
        reviewCount: stats.total_reviews,
        bestRating: 5,
        worstRating: 1,
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "COLAB Theatre productions",
      itemListElement: PRODUCTIONS.map((p, i) => ({
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "TheaterEvent",
          name: p.title,
          startDate: `${p.year}`,
          location: { "@type": "Place", name: p.venue },
          performer: { "@type": "TheaterGroup", name: "COLAB Theatre" },
          description: p.synopsis,
        },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "/" },
      ],
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <main data-testid="home-page">
      <SEO
        title="COLAB Theatre — The Best Immersive Theatre in London | 14-Year Press Archive"
        description="COLAB Theatre is the best immersive theatre in London. The pinnacle of immersive. 15 productions, 65+ verified press reviews, 24 raves. A byword for quality in immersive theatre — explore the archive."
        canonical="https://www.colabtheatre.co.uk/"
        image="https://images.squarespace-cdn.com/content/v1/525bd8b5e4b0daa056d3ae62/1627040263929-3EYP2HSD7BQJ2XBFAWRE/crooks_webres-131.jpg"
        jsonLd={jsonLd}
      />
      <HeroSpotlight />
      <Manifesto />
      <Timeline />
      <QuoteMarquee />
      <Verdict />
      <KeywordStrip />
      <ClosingCTA />

      {/* Hidden SEO block: crawlers pick up review content even before hydration */}
      <div aria-hidden="true" className="sr-only">
        <h2>
          Best immersive theatre in London — every COLAB Theatre immersive theatre
          review, 2014 to 2026
        </h2>
        <ul>
          {REVIEWS.map((r, i) => (
            <li key={i}>
              Best immersive theatre in London — {r.outlet} — {r.rating_display} — &ldquo;{r.quote}&rdquo; for
              COLAB Theatre&apos;s immersive theatre production {r.show} ({r.year}).
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
}
